import React, { useCallback, useEffect, useState } from 'react';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { useCreateLectureContentMutation } from '@classCreation/services/lectureContentService';
import FieldErrors from 'components/FieldErrors';
import Form from 'components/Form';
import LectureContentInput from '../LectureContentInput';

export default function CreateLectureContentForm({
  academyTopicId,
  contentType,
  onSuccess,
  label,
}) {
  const [lectureContent, setLectureContent] = useState();
  const [createLectureContent, { isSuccess, error, isLoading: isCreating }] =
    useCreateLectureContentMutation();

  const handleOnChange = useCallback((newContent) => {
    setLectureContent(newContent);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lecture content is successfully created!');
      onSuccess();
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in creating the lecture content. Please try again later!'
      );
    }
  }, [error, isSuccess, onSuccess]);

  const handleCreateContent = useCallback(
    (event) => {
      event.preventDefault();
      createLectureContent({ academyTopicId, content: lectureContent });
    },
    [academyTopicId, createLectureContent, lectureContent]
  );

  return (
    <Form onSubmit={handleCreateContent}>
      <LectureContentInput
        contentType={contentType}
        value={lectureContent}
        onChange={handleOnChange}
        placeholder={`Enter ${label}`}
      />
      <FieldErrors
        name="content"
        errors={error?.data?.errors}
      />
      <Tappable
        className="btn btn-primary m-v-xxs"
        disabled={isCreating}
        component="button"
        type="submit"
      >
        Create {label}
      </Tappable>
    </Form>
  );
}
